import React from 'react';
import { ChevronUp, ChevronDown, ArrowUpDown } from 'lucide-react';

const SortableHeader = ({ label, sortKey, align = 'left', sortConfig, onSort }) => {
    const handleClick = () => {
        onSort(sortKey);
    };

    return (
        <th
            className={`px-6 py-3 text-${align} text-xs font-medium text-slate-500 uppercase tracking-wider cursor-pointer hover:bg-slate-100 transition-colors group select-none`}
            onClick={handleClick}
        >
            <div className={`flex items-center gap-1 ${align === 'right' ? 'justify-end' : ''}`}>
                {label}
                {sortConfig.key === sortKey ? (
                    sortConfig.direction === 'asc' ? <ChevronUp size={14} className="text-indigo-600" /> : <ChevronDown size={14} className="text-indigo-600" />
                ) : (
                    <ArrowUpDown size={14} className="text-slate-300 group-hover:text-slate-500" />
                )}
            </div>
        </th>
    );
};

export default SortableHeader;